# ==============================================================================
# imgタグにdata-event="mouse-in-out"をつけると
# マウスオーバーアウトで画像を差し替える
# ==============================================================================
do ->
	inOut = (e)->
		if e.type is 'mouseover'
			reg   = /\/*.(jpg|jpeg|gif|png)$/
			rpd   = '--over.$1'
			$this = $(this)
			src   = $this.attr('src').replace(reg,rpd)
			$this.attr('src',src)
		else if e.type is 'mouseout'
			reg   = /\/*--over.(jpg|jpeg|gif|png)$/
			rpd   = '.$1'
			$this = $(this)
			src   = $this.attr('src').replace(reg,rpd)
			$this.attr('src',src)
		return
	$overs = $('img[data-event="mouse-in-out"]')
	$overs.on(
		'mouseover' : inOut
		'mouseout'  : inOut
	)
	return

# ==============================================================================
# aタグにdeta-event="child-window"をつけると
# 子ウィンドウで開きます。
# ==============================================================================
do->
	$('a[data-event^="child-window"]').on('click',(e)->
		e.preventDefault()
		$this = $(this)
		url   = $this.attr('href')
		param = $this.attr('data-event').split('--')[1]
		param = param || ''
		name  = $this.attr('name') || 'child-window'
		window.open(url,name,param)
		return
	)

	return


# ==============================================================================
# module side-product-menuの処理
# ==============================================================================
do->
	$module = $('.module__side-product-menu')
	$overs  = $(' > ul > li > a > img',$module)
	# --------------------------------------------------------------------------
	# マウス インアウトで画像差し替え
	# --------------------------------------------------------------------------
	inOut = (e)->
		if e.type is 'mouseover'
			reg   = /\/*.(jpg|jpeg|gif|png)$/
			rpd   = '--over.$1'
			$this = $(this)
			if $this.hasClass('change-stop') then return
			src   = $this.attr('src').replace(reg,rpd)
			$this.attr('src',src)
		else if e.type is 'mouseout'
			reg   = /\/*--over.(jpg|jpeg|gif|png)$/
			rpd   = '.$1'
			$this = $(this)
			if $this.hasClass('change-stop') then return
			src   = $this.attr('src').replace(reg,rpd)
			$this.attr('src',src)
		return
	# イベントの登録 -----------------------------------------------------------
	$overs.on(
		'mouseover' : inOut
		'mouseout'  : inOut
	)
	# --------------------------------------------------------------------------
	# 大カテゴリーリストをクリックした時の処理
	# --------------------------------------------------------------------------
	$(' > ul > li > a',$module).on('click',(e)->
		$this   = $(e.currentTarget)
		$parent = $this.parent()
		$child  = null
		if $parent.hasClass('has_child')
			e.preventDefault()
			$child = $('ul',$parent)
			$child.stop().slideToggle(250)
		return
	)
	# --------------------------------------------------------------------------
	# カテゴリーページや詳細ページなど最初から開いておくべき箇所があれば開く
	# --------------------------------------------------------------------------
	$(' > ul > li[data-this="true"] > a > img',$module).trigger('mouseover').addClass('change-stop')
	$(' > ul > li[data-this="true"] > ul',$module).slideToggle(0)

	return
